import script from "./fw10_Articles_Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./fw10_Articles_Edit.vue?vue&type=script&setup=true&lang=js"

import "./fw10_Articles_Edit.vue?vue&type=style&index=0&id=2b8ce6ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8ce6ad"]])

export default __exports__